export const DEFAULT_REMARKABLE_OPTIONS = {
  breaks: true,
  linkTarget: '_blank',
  html: true,
};

export const DISABLE_HTML_REMARKABLE_OPTIONS = { html: false };
